import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/_services/ui/alert.service';


@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})

export class AlertComponent implements OnInit, OnDestroy {
    private subscription!: Subscription;

    public alert: any;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.subscription = this.alertService.onAlert()
            .subscribe(alert => {
                switch (alert?.type) {
                    case 'success':
                        alert.cssClass = 'alert-success';
                        break;
                    case 'warning':
                        alert.cssClass = 'alert-warning';
                        break;
                    case 'error':
                        alert.cssClass = 'alert-error';
                        break;
                }

                this.alert = alert;
            });
    }

    closeAlert() {
        this.alert = null;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}